import {
  AreaChartOutlined,
  BarChartOutlined,
  BarcodeOutlined,
  CloseCircleOutlined,
  FileDoneOutlined,
  FileProtectOutlined,
  FileTextOutlined,
  IssuesCloseOutlined,
  MedicineBoxOutlined,
  PieChartOutlined,
  PrinterOutlined,
  ProfileOutlined,
  ReadOutlined,
  SlidersOutlined,
  SyncOutlined,
  TruckFilled,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import { NAV_STYLE_NO_HEADER_MINI_SIDEBAR } from "constants/ThemeSetting";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { TEST_STATUS } from "utils/Config";
import { UserRoleEnums } from "utils/Constant";
import { programEnum } from "utils/Helpers";
import IntlMessages from "utils/IntlMessages";

const { ItemGroup: MenuItemGroup, Item: MenuItem, SubMenu } = Menu;

const getNavStyleSubMenuClass = (navStyle) =>
  navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR
    ? "gx-no-header-submenu-popup"
    : "";

const PublicProgramsMenuSection = ({
  roles,
  role,
  isGlobalAdmin,
  isFacilityAdmin,
  canSeeFacilityAnalytics,
  currentProgram,
  flatPublicPrograms,
  currentState,
  currentLga,
  navStyle,
  countUi,
}) => {
  const {
    MANAGER,
    SUPERVISOR,
    DATA_ANALYST,
    RECEPTIONIST,
    DATA_CLERK,
    ANALYST,
  } = UserRoleEnums;

  return (
    <>
      {flatPublicPrograms && roles.includes(MANAGER) && (
        <div className="hidden">
          <MenuItemGroup
            key="facilityAnalyticsFacility"
            className="gx-menu-group"
            title={<IntlMessages id="sidebar.facilityAnalytics" />}
          >
            <SubMenu
              key="dashboards/facility"
              popupClassName={getNavStyleSubMenuClass(navStyle)}
              title={
                <span className="items-center">
                  <AreaChartOutlined className="icon" />
                  <span className="enlis-submenu">
                    <IntlMessages id="sidebar.dashboardFacility" />
                  </span>
                </span>
              }
            >
              <MenuItem key="dashboards/facility">
                <Link to="/dashboards/facility">
                  <span className="enlis-submenu">
                    <IntlMessages id="sidebar.dashboardFacility" />
                  </span>
                </Link>
              </MenuItem>
              <MenuItem key="dashboards/general_program">
                <Link to="/dashboards/general_program">
                  <span className="enlis-submenu">
                    <IntlMessages id="sidebar.dashboardCOVID" />
                  </span>
                </Link>
              </MenuItem>
            </SubMenu>
            <SubMenu
              key="facility-report"
              popupClassName={getNavStyleSubMenuClass(navStyle)}
              title={
                <span className="items-center">
                  <AreaChartOutlined className="icon" />
                  <span className="enlis-submenu">
                    <IntlMessages id="sidebar.facilityReport" />
                  </span>
                </span>
              }
            >
              <MenuItem key="reports/ph-report">
                <Link to="/reports/ph-report">
                  <span className="enlis-submenu">
                    <IntlMessages id="sidebar.tableReport" />
                  </span>
                </Link>
              </MenuItem>
            </SubMenu>
          </MenuItemGroup>
          {!currentState && !currentLga && (
            <MenuItemGroup
              key="federalAnalyticsFacility"
              className="gx-menu-group"
              title={<IntlMessages id="sidebar.federalAnalytics" />}
            >
              <MenuItem key="dashboards/federalCovid">
                <Link to="/dashboards/federalCovid">
                  <PieChartOutlined className="icon" />
                  <span>
                    <IntlMessages id="sidebar.dashboardCOVID" />
                  </span>
                </Link>
              </MenuItem>
              <MenuItem key="dashboards/federalLassa">
                <Link to="/dashboards/federalLassa">
                  <SlidersOutlined className="icon" />
                  <span>
                    <IntlMessages id="sidebar.dashboardLASSA" />
                  </span>
                </Link>
              </MenuItem>
            </MenuItemGroup>
          )}
          {currentState && !currentLga && (
            <MenuItemGroup
              key="stateAnalyticsFacility"
              className="gx-menu-group"
              title={<IntlMessages id="sidebar.stateAnalytics" />}
            >
              <MenuItem key="dashboards/stateCovid">
                <Link to="/dashboards/stateCovid">
                  <PieChartOutlined className="icon" />
                  <span>
                    <IntlMessages id="sidebar.dashboardCOVID" />
                  </span>
                </Link>
              </MenuItem>
              <MenuItem key="dashboards/stateLassa">
                <Link to="/dashboards/stateLassa">
                  <SlidersOutlined className="icon" />
                  <span>
                    <IntlMessages id="sidebar.dashboardLASSA" />
                  </span>
                </Link>
              </MenuItem>
            </MenuItemGroup>
          )}
          {currentLga && (
            <MenuItemGroup
              key="lgaAnalytics"
              className="gx-menu-group"
              title={<IntlMessages id="sidebar.lgaAnalytics" />}
            >
              <MenuItem key="dashboards/lgaCovid">
                <Link to="/dashboards/lgaCovid">
                  <PieChartOutlined className="icon" />
                  <span>
                    <IntlMessages id="sidebar.dashboardCOVID" />
                  </span>
                </Link>
              </MenuItem>
              <MenuItem key="dashboards/lgaLassa">
                <Link to="/dashboards/lgaLassa">
                  <SlidersOutlined className="icon" />
                  <span>
                    <IntlMessages id="sidebar.dashboardLASSA" />
                  </span>
                </Link>
              </MenuItem>
            </MenuItemGroup>
          )}
        </div>
      )}

      {canSeeFacilityAnalytics && (
        <MenuItemGroup
          key="analytics"
          className="gx-menu-group"
          title={<IntlMessages id="sidebar.analytics" />}
        >
          {currentProgram === programEnum.TB && (
            <>
              <MenuItem key="programs/tb-dashboard">
                <Link to="/programs/tb-dashboard">
                  <PieChartOutlined className="icon" />
                  <span>
                    <IntlMessages id="sidebar.dashboard" />
                  </span>
                </Link>
              </MenuItem>
              <MenuItem key="programs/tb-report">
                <Link to="/programs/tb-report">
                  <ReadOutlined className="icon" />
                  <span>
                    <IntlMessages id="sidebar.report" />
                  </span>
                </Link>
              </MenuItem>
              {(role === SUPERVISOR || role === DATA_ANALYST) && (
                <MenuItem key="manage-result">
                  <Link to="/manage-result">
                    <FileDoneOutlined className="icon" />
                    <span>
                      <IntlMessages id="sidebar.manageResult" />
                    </span>
                  </Link>
                </MenuItem>
              )}
            </>
          )}
          {currentProgram === programEnum.EID && (
            <MenuItem key="dashboards/eid">
              <Link to="/dashboards/eid">
                <BarChartOutlined className="icon" />
                <span>
                  <IntlMessages id="sidebar.dashboard" />
                </span>
              </Link>
            </MenuItem>
          )}
          {currentProgram === programEnum.VIRAL_LOAD && (
            <MenuItem key="dashboards/viral_load">
              <Link to="/dashboards/viral_load">
                <BarChartOutlined className="icon" />
                <span>
                  <IntlMessages id="sidebar.dashboard" />
                </span>
              </Link>
            </MenuItem>
          )}

          {flatPublicPrograms?.includes(currentProgram) && (
            <>
              <MenuItem key="programs/ph-dashboard">
                <Link to="/programs/ph-dashboard">
                  <PieChartOutlined className="icon" />
                  <span>
                    <IntlMessages id="sidebar.dashboard" />
                  </span>
                </Link>
              </MenuItem>
              <MenuItem key="reports">
                <Link to="/reports">
                  <ReadOutlined className="icon" />
                  <span>
                    <IntlMessages id="sidebar.report" />
                  </span>
                </Link>
              </MenuItem>
              {(role === SUPERVISOR || role === DATA_ANALYST) && (
                <MenuItem key="manage-result">
                  <Link to="/manage-result">
                    <FileDoneOutlined className="icon" />
                    <span>
                      <IntlMessages id="sidebar.manageResult" />
                      {countUi(TEST_STATUS.RESULT.APPROVAL)}
                    </span>
                  </Link>
                </MenuItem>
              )}
            </>
          )}
        </MenuItemGroup>
      )}

      {!isGlobalAdmin && !isFacilityAdmin && role !== DATA_ANALYST && (
        <MenuItemGroup
          key="main"
          className="gx-menu-group"
          title={<IntlMessages id="sidebar.main" />}
        >
          {currentProgram === programEnum.TB && (
            <>
              {(roles.includes(RECEPTIONIST) ||
                roles.includes(DATA_CLERK) ||
                roles.includes(SUPERVISOR)) &&
                [RECEPTIONIST, DATA_CLERK, SUPERVISOR].includes(role) && (
                  <>
                    <MenuItem key="programs/tb-manage-sample">
                      <Link to="/programs/tb-manage-sample">
                        <UnorderedListOutlined className="icon icon-widgets" />
                        <span>
                          <IntlMessages id="sidebar.manageTbSamplePage" />
                          {countUi([
                            TEST_STATUS.SAMPLE.ORDERED,
                            TEST_STATUS.SAMPLE.APPROVED,
                          ])}
                        </span>
                      </Link>
                    </MenuItem>
                    <MenuItem key="programs/ph-rejected-sample">
                      <Link to="/programs/ph-rejected-sample">
                        <CloseCircleOutlined className="icon icon-widgets" />
                        <span>
                          <IntlMessages id="sidebar.rejectedSample" />
                          {countUi([
                            TEST_STATUS.SAMPLE.REJECTED,
                            TEST_STATUS.SAMPLE.PARTIAL_REJECTED,
                          ])}
                        </span>
                      </Link>
                    </MenuItem>
                    <MenuItem key="programs/tb-sample-reception">
                      <Link to="/programs/tb-sample-reception">
                        <MedicineBoxOutlined className="icon icon-widgets" />

                        <span>
                          <IntlMessages id="sidebar.sampleReception" />
                        </span>
                      </Link>
                    </MenuItem>
                  </>
                )}
              {roles.includes(SUPERVISOR) && role === SUPERVISOR && (
                <MenuItem key="dispatch">
                  <Link to="/dispatch">
                    <TruckFilled className="icon icon-widgets" />
                    <span>
                      <IntlMessages id="sidebar.dispatch" />
                    </span>
                  </Link>
                </MenuItem>
              )}
              {(roles.includes(ANALYST) || roles.includes(SUPERVISOR)) &&
                [ANALYST, SUPERVISOR].includes(role) && (
                  <>
                    <MenuItem key="programs/tb-workplan">
                      <Link to="/programs/tb-workplan">
                        <PrinterOutlined className="icon icon-widgets" />
                        <span>
                          <IntlMessages id="sidebar.workplan" />
                        </span>
                      </Link>
                    </MenuItem>
                    <MenuItem key="programs/ph-retest">
                      <Link to="/programs/ph-retest">
                        <SyncOutlined className="icon" />
                        <span>
                          <IntlMessages id="sidebar.reTestSample" />
                        </span>
                      </Link>
                    </MenuItem>
                  </>
                )}
              {(roles.includes(DATA_CLERK) ||
                roles.includes(ANALYST) ||
                roles.includes(SUPERVISOR)) &&
                [DATA_CLERK, ANALYST, SUPERVISOR].includes(role) && (
                  <MenuItem key="programs/tb-manual-result">
                    <Link to="/programs/tb-manual-result">
                      <ProfileOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.results.manualResults" />
                      </span>
                    </Link>
                  </MenuItem>
                )}

              {roles.includes(SUPERVISOR) && role === SUPERVISOR && (
                <>
                  <MenuItem key="programs/tb-validate-result">
                    <Link to="/programs/tb-validate-result">
                      <IssuesCloseOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.results.validateResults" />
                      </span>
                    </Link>
                  </MenuItem>
                  <MenuItem key="programs/tb-approve-results">
                    <Link to="/programs/tb-approve-results">
                      <FileProtectOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.results.approveResults" />
                      </span>
                    </Link>
                  </MenuItem>
                </>
              )}
            </>
          )}
          {currentProgram === programEnum.EID && (
            <>
              {(roles.includes(RECEPTIONIST) ||
                roles.includes(DATA_CLERK) ||
                roles.includes(SUPERVISOR)) &&
                [RECEPTIONIST, DATA_CLERK, SUPERVISOR].includes(role) && (
                  <>
                    <MenuItem key="programs/eid-manage-sample">
                      <Link to="/programs/eid-manage-sample">
                        <UnorderedListOutlined className="icon icon-widgets" />
                        <span>
                          <IntlMessages id="sidebar.manageEidSamplePage" />
                        </span>
                      </Link>
                    </MenuItem>
                    <MenuItem key="programs/eid-sample-reception">
                      <Link to="/programs/eid-sample-reception">
                        <MedicineBoxOutlined className="icon icon-widgets" />
                        <span>
                          <IntlMessages id="sidebar.sampleReception" />
                        </span>
                      </Link>
                    </MenuItem>
                  </>
                )}
              {roles.includes(SUPERVISOR) && role === SUPERVISOR && (
                <MenuItem key="programs/eid-approve">
                  <Link to="/programs/eid-approve">
                    <FileDoneOutlined className="icon icon-widgets" />
                    <span>
                      <IntlMessages id="sidebar.eidSampleApprovePage" />
                    </span>
                  </Link>
                </MenuItem>
              )}
              {(roles.includes(ANALYST) || roles.includes(SUPERVISOR)) &&
                [ANALYST, SUPERVISOR].includes(role) && (
                  <MenuItem key="programs/eid-workplan">
                    <Link to="/programs/eid-workplan">
                      <PrinterOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.workplan" />
                      </span>
                    </Link>
                  </MenuItem>
                )}

              {(roles.includes(DATA_CLERK) ||
                roles.includes(ANALYST) ||
                roles.includes(SUPERVISOR)) &&
                [DATA_CLERK, ANALYST, SUPERVISOR].includes(role) && (
                  <MenuItem key="programs/eid-manual-result">
                    <Link to="/programs/eid-manual-result">
                      <ProfileOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.results.manualResults" />
                      </span>
                    </Link>
                  </MenuItem>
                )}

              {roles.includes(SUPERVISOR) && role === SUPERVISOR && (
                <MenuItem key="programs/eid-approve-results">
                  <Link to="/programs/eid-approve-results">
                    <FileProtectOutlined className="icon icon-widgets" />
                    <span>
                      <IntlMessages id="sidebar.results.approveResults" />
                    </span>
                  </Link>
                </MenuItem>
              )}
            </>
          )}
          {currentProgram === programEnum.VIRAL_LOAD && (
            <>
              {(roles.includes(RECEPTIONIST) ||
                roles.includes(DATA_CLERK) ||
                roles.includes(SUPERVISOR)) &&
                [RECEPTIONIST, DATA_CLERK, SUPERVISOR].includes(role) && (
                  <>
                    <MenuItem key="programs/vl-manage-sample">
                      <Link to="/programs/vl-manage-sample">
                        <UnorderedListOutlined className="icon icon-widgets" />
                        <span>
                          <IntlMessages id="sidebar.manageVLSamplePage" />
                        </span>
                      </Link>
                    </MenuItem>
                    <MenuItem key="programs/vl-sample-reception">
                      <Link to="/programs/vl-sample-reception">
                        <MedicineBoxOutlined className="icon icon-widgets" />
                        <span>
                          <IntlMessages id="sidebar.sampleReception" />
                        </span>
                      </Link>
                    </MenuItem>
                  </>
                )}
              {roles.includes(SUPERVISOR) && role === SUPERVISOR && (
                <>
                  <MenuItem key="programs/vl-approve">
                    <Link to="/programs/vl-approve">
                      <FileDoneOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.vlSampleApprovePage" />
                      </span>
                    </Link>
                  </MenuItem>
                  <MenuItem key="dispatch">
                    <Link to="/dispatch">
                      <TruckFilled className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.dispatch" />
                      </span>
                    </Link>
                  </MenuItem>
                </>
              )}
              {(roles.includes(ANALYST) || roles.includes(SUPERVISOR)) &&
                [ANALYST, SUPERVISOR].includes(role) && (
                  <MenuItem key="programs/vl-workplan">
                    <Link to="/programs/vl-workplan">
                      <PrinterOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.workplan" />
                      </span>
                    </Link>
                  </MenuItem>
                )}

              {(roles.includes(DATA_CLERK) ||
                roles.includes(ANALYST) ||
                roles.includes(SUPERVISOR)) &&
                [DATA_CLERK, ANALYST, SUPERVISOR].includes(role) && (
                  <MenuItem key="programs/vl-manual-result">
                    <Link to="/programs/vl-manual-result">
                      <ProfileOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.results.manualResults" />
                      </span>
                    </Link>
                  </MenuItem>
                )}

              {roles.includes(SUPERVISOR) && role === SUPERVISOR && (
                <MenuItem key="programs/vl-approve-results">
                  <Link to="/programs/vl-approve-results">
                    <FileProtectOutlined className="icon icon-widgets" />
                    <span>
                      <IntlMessages id="sidebar.results.approveResults" />
                    </span>
                  </Link>
                </MenuItem>
              )}
            </>
          )}

          {flatPublicPrograms?.includes(currentProgram) && (
            <>
              {(roles.includes(RECEPTIONIST) ||
                roles.includes(DATA_CLERK) ||
                roles.includes(SUPERVISOR)) &&
                [SUPERVISOR, RECEPTIONIST, DATA_CLERK].includes(role) && (
                  <>
                    <MenuItem key="programs/ph-manage-sample">
                      <Link to="/programs/ph-manage-sample">
                        <BarcodeOutlined className="icon icon-widgets" />
                        <span>
                          <IntlMessages id="sidebar.manageSample" />
                          {countUi([
                            TEST_STATUS.SAMPLE.ORDERED,
                            TEST_STATUS.SAMPLE.APPROVED,
                          ])}
                        </span>
                      </Link>
                    </MenuItem>
                    <MenuItem key="programs/ph-rejected-sample">
                      <Link to="/programs/ph-rejected-sample">
                        <CloseCircleOutlined className="icon icon-widgets" />
                        <span>
                          <IntlMessages id="sidebar.rejectedSample" />
                          {countUi([
                            TEST_STATUS.SAMPLE.REJECTED,
                            TEST_STATUS.SAMPLE.PARTIAL_REJECTED,
                          ])}
                        </span>
                      </Link>
                    </MenuItem>
                  </>
                )}

              {(roles.includes(RECEPTIONIST) || roles.includes(SUPERVISOR)) &&
                [SUPERVISOR, RECEPTIONIST].includes(role) && (
                  <MenuItem key="programs/ph-sample-reception">
                    <Link to="/programs/ph-sample-reception">
                      <MedicineBoxOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.sampleReception" />
                        {countUi([
                          TEST_STATUS.SAMPLE.COLLECTED,
                          TEST_STATUS.SAMPLE.DISPATCHED,
                        ])}
                      </span>
                    </Link>
                  </MenuItem>
                )}

              {roles.includes(SUPERVISOR) && [SUPERVISOR].includes(role) && (
                <MenuItem key="dispatch">
                  <Link to="/dispatch">
                    <TruckFilled className="icon icon-widgets" />
                    <span>
                      <IntlMessages id="sidebar.dispatch" />
                      {countUi(TEST_STATUS.SAMPLE.APPROVED)}
                    </span>
                  </Link>
                </MenuItem>
              )}
              {(roles.includes(ANALYST) || roles.includes(SUPERVISOR)) &&
                [ANALYST, SUPERVISOR].includes(role) && (
                  <>
                    <MenuItem key="programs/ph-workplan">
                      <Link to="/programs/ph-workplan">
                        <PrinterOutlined className="icon icon-widgets" />
                        <span>
                          <IntlMessages id="sidebar.workplan" />
                          {countUi([
                            TEST_STATUS.SAMPLE.APPROVED,
                            TEST_STATUS.SAMPLE.PARTIAL_REJECTED,
                            TEST_STATUS.SAMPLE.RE_RUN,
                          ])}
                        </span>
                      </Link>
                    </MenuItem>
                    <MenuItem key="programs/ph-worksheet">
                      <Link to="/programs/ph-worksheet">
                        <BarcodeOutlined className="icon" />
                        <span>
                          <IntlMessages id="sidebar.createWorksheet" />
                          {countUi([
                            TEST_STATUS.SAMPLE.APPROVED,
                            TEST_STATUS.SAMPLE.PARTIAL_REJECTED,
                            TEST_STATUS.SAMPLE.RE_RUN,
                          ])}
                        </span>
                      </Link>
                    </MenuItem>
                    {/* <MenuItem key="programs/ph-worksheet-archive">
                      <Link to="/programs/ph-worksheet-archive">
                        <FileTextOutlined className="icon" />
                        <span>
                          <IntlMessages id="sidebar.archivedWorksheet" />
                        </span>
                      </Link>
                    </MenuItem> */}
                    <MenuItem key="programs/ph-retest">
                      <Link to="/programs/ph-retest">
                        <SyncOutlined className="icon" />
                        <span>
                          <IntlMessages id="sidebar.reTestSample" />
                        </span>
                      </Link>
                    </MenuItem>
                  </>
                )}

              {(roles.includes(DATA_CLERK) ||
                roles.includes(ANALYST) ||
                roles.includes(SUPERVISOR)) &&
                [DATA_CLERK, ANALYST, SUPERVISOR].includes(role) && (
                  <MenuItem key="programs/ph-manual-result">
                    <Link to="/programs/ph-manual-result">
                      <ProfileOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.results.manualResults" />
                        {countUi([
                          TEST_STATUS.SAMPLE.APPROVED,
                          TEST_STATUS.SAMPLE.ONGOING,
                        ])}
                      </span>
                    </Link>
                  </MenuItem>
                )}

              {(roles.includes(ANALYST) || roles.includes(SUPERVISOR)) &&
                [ANALYST, SUPERVISOR].includes(role) && (
                  <MenuItem key="programs/ph-quality-control">
                    <Link to="/programs/ph-quality-control">
                      <FileDoneOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.results.qualityControl" />
                      </span>
                    </Link>
                  </MenuItem>
                )}

              {roles.includes(SUPERVISOR) && [SUPERVISOR].includes(role) && (
                <>
                  <MenuItem key="programs/ph-validate-result">
                    <Link to="/programs/ph-validate-result">
                      <IssuesCloseOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.results.validateResults" />
                        {countUi([TEST_STATUS.RESULT.ENTERED])}
                      </span>
                    </Link>
                  </MenuItem>
                  <MenuItem key="programs/ph-approve-results">
                    <Link to="/programs/ph-approve-results">
                      <FileProtectOutlined className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.results.approveResults" />
                        {countUi([TEST_STATUS.RESULT.VERIFIED])}
                      </span>
                    </Link>
                  </MenuItem>
                  <Menu.Item key="programs/ph-worksheet-archive">
                    <Link to="/programs/ph-worksheet-archive">
                      <FileTextOutlined className="icon" />
                      <span>
                        <IntlMessages id="sidebar.archivedWorksheet" />
                      </span>
                    </Link>
                  </Menu.Item>
                </>
              )}
            </>
          )}
        </MenuItemGroup>
      )}
    </>
  );
};

export default PublicProgramsMenuSection;

PublicProgramsMenuSection.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  role: PropTypes.string,
  isGlobalAdmin: PropTypes.bool.isRequired,
  isFacilityAdmin: PropTypes.bool.isRequired,
  canSeeFacilityAnalytics: PropTypes.bool.isRequired,
  currentProgram: PropTypes.string,
  flatPublicPrograms: PropTypes.arrayOf(PropTypes.string),
  currentState: PropTypes.any,
  currentLga: PropTypes.any,
  navStyle: PropTypes.string,
  countUi: PropTypes.func.isRequired,
};
